module.exports = __webpack_public_path__ + "static/media/M.882ca599.svg";